export function isProd() {
    return window.location.hostname === 'mikebrauninger.com';
}
